import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { CategoryPage } from './pages/CategoryPage';
import { BuyingGuides } from './pages/BuyingGuides';
import { Reviews } from './pages/Reviews';
import { ReviewDetail } from './pages/ReviewDetail';
import { Research } from './pages/Research';
import { TrustFramework } from './pages/TrustFramework';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/energy" element={<CategoryPage data-id="element-6" />} data-id="element-5" />
          <Route path="/preparedness" element={<CategoryPage data-id="element-8" />} data-id="element-7" />
          <Route path="/water" element={<CategoryPage data-id="element-10" />} data-id="element-9" />
          <Route path="/smart-home" element={<CategoryPage data-id="element-12" />} data-id="element-11" />
          <Route path="/buying-guides" element={<BuyingGuides data-id="element-14" />} data-id="element-13" />
          <Route path="/buying-guides/:slug" element={<BuyingGuides data-id="element-16" />} data-id="element-15" />
          <Route path="/reviews" element={<Reviews data-id="element-18" />} data-id="element-17" />
          <Route path="/reviews/:slug" element={<ReviewDetail data-id="element-20" />} data-id="element-19" />
          <Route path="/research" element={<Research data-id="element-22" />} data-id="element-21" />
          <Route path="/agreexa-trust-framework" element={<TrustFramework data-id="element-24" />} data-id="element-23" />
          <Route path="/about" element={<About data-id="element-26" />} data-id="element-25" />
          <Route path="/contact" element={<Contact data-id="element-28" />} data-id="element-27" />
          <Route path="*" element={<Home data-id="element-30" />} data-id="element-29" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}